import React from "react";

export default (props) => (
    <span aria-hidden={"true"}>
        <i className={"sprite sprite-cancel-lg"} />
    </span>
);
